import React, { useState } from "react";
import { Icon } from '@iconify/react';
import './styles/style.scss';

const ContactInfo = ({ formState, setFormState, pageState, setPageState }) => {
  const onInputChange = (e) => {
    setPageState({
      ...pageState,
      [e.target.name]: e.target.value,
    })
  }

  return (
    <div>
      <h1 className="title"><Icon icon="mdi:hand-wave-outline" /> <b>Hello!</b></h1>
      <p>Please fill out all of the following information:</p>
      <form id="form" className="form">
        <fieldset className="name-container">
          <div className="name">
            <input onChange={onInputChange} value={pageState.first_name} name="first_name" type="text" id="first_name" required className="input" />
            <label htmlFor="first_name" className="input-label">First Name</label>
          </div>
        </fieldset>
        <fieldset>
          <div className="name">
            <input onChange={onInputChange} value={pageState.last_name} name="last_name" type="text" id="last_name" required className="input" />
            <label htmlFor="last_name" className="input-label">Last Name</label>
          </div>
        </fieldset>
        <fieldset>
          <input onChange={onInputChange} value={pageState.email} name="email" type="text" id="email" required className="input" />
          <label htmlFor="email" className="input-label">Email Address</label>
        </fieldset>
        <fieldset>
          <input onChange={onInputChange} value={pageState.phone} name="phone" type="text" id="phone" required className="input" />
          <label htmlFor="phone" className="input-label">Cell Phone Number</label>
        </fieldset>
        <fieldset>
          <input onChange={onInputChange} value={pageState.phone_2} name="phone_2" type="text" id="phone_2" required className="input" />
          <label htmlFor="phone_2" className="input-label">Work Phone Number</label>
        </fieldset>
      </form>
    </div>
  )
}

export default ContactInfo;